import * as React from 'react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { observer } from 'src/utils/mobx-react';
import { getTeamLogo } from 'src/domains/sportsbook/webview/components/eventsList/eventRowNFL/NFLTeamLogos';
import { slug } from 'src/utils/deburr';
import bgPatternHexagon from 'src/domains/layouts/shared/assets/backgrounds/sports/bgPatternHexagon.webp';
import bgImage from 'src/domains/layouts/shared/assets/backgrounds/sports/desktop/bgFootballNew.webp';
import { DateTime } from 'src_common/utils/time/time';
import { getTeamName } from 'src/domains/sportsbook/webview/components/matchLead/PreMatch';
import {
    At,
    NFLIconWrapper,
    NflTeamLogotype,
    PreMatchParticipantNameNfl,
    PreMatchWrapperNfl,
} from 'src/domains/sportsbook/webview/components/matchLead/PreMatchNFL.style';
import {
    PreMatchDate,
    PreMatchDateTime,
    PreMatchParticipantName,
    PreMatchParticipantNameWrapper,
    PreMatchParticipants,
    PreMatchTime,
    PreMatchWrapper,
    Versus,
} from 'src/domains/sportsbook/webview/components/matchLead/PreMatch.style';
import { useAppStateContext } from 'src/appState/AppState';

const getTeamSlugName = (name: string | null | undefined): string => {
    if (name !== null && name !== undefined) {
        return slug(name);
    }

    return '';
};

interface PreMatchNFLPropsType {
    event: EventModel;
}

export const PreMatchNFL = observer('PreMatchNFL', ({ event }: PreMatchNFLPropsType) => {
    const { unifiedComponentConfig } = useAppStateContext();
    const startTime = DateTime.from(event.timeSettingsStartTime);

    const home = getTeamName(event, 'home');
    const away = getTeamName(event, 'away');

    // TODO: [Genius] To remove this check and leave only componentVariants.sportsbookVariant when GLOB-37 is fully live
    const {
        componentVariants: { sportsbookVariant },
        unifiedSportEventsTable,
    } = unifiedComponentConfig;

    const eventDateStart = unifiedSportEventsTable ? startTime?.format('ddd DD MMM') : startTime?.format('ddd Do MMM');
    const eventTimeStart = startTime?.format('HH:mm');

    if (unifiedSportEventsTable) {
        return (
            <PreMatchWrapper
                bgImage={bgImage}
                variant={sportsbookVariant}
            >
                <PreMatchParticipants>
                    <PreMatchParticipantNameWrapper>
                        <PreMatchParticipantName>{away === undefined ? '-' : away.name}</PreMatchParticipantName>
                    </PreMatchParticipantNameWrapper>
                    <PreMatchDateTime variant={sportsbookVariant}>
                        <Versus
                            variant={sportsbookVariant}
                            isNFL
                        />
                        <PreMatchDate variant={sportsbookVariant}>{`${eventDateStart} ${eventTimeStart}`}</PreMatchDate>
                    </PreMatchDateTime>
                    <PreMatchParticipantNameWrapper>
                        <PreMatchParticipantName>{home === undefined ? '-' : home.name}</PreMatchParticipantName>
                    </PreMatchParticipantNameWrapper>
                </PreMatchParticipants>
            </PreMatchWrapper>
        );
    }

    return (
        <PreMatchWrapperNfl
            bgImage={bgPatternHexagon}
            variant={sportsbookVariant}
        >
            <PreMatchDate variant={sportsbookVariant}>
                {eventDateStart}
                <PreMatchTime>{eventTimeStart}</PreMatchTime>
            </PreMatchDate>

            <PreMatchParticipants>
                <PreMatchParticipantNameNfl>
                    {away === undefined ? '-' : away.name}
                    <NflTeamLogotype
                        src={getTeamLogo(getTeamSlugName(away?.name))}
                        alt={getTeamSlugName(away?.name)}
                    />
                </PreMatchParticipantNameNfl>
                <At>@</At>
                <PreMatchParticipantNameNfl>
                    <NflTeamLogotype
                        src={getTeamLogo(getTeamSlugName(home?.name))}
                        alt={getTeamSlugName(home?.name)}
                    />
                    {home === undefined ? '-' : home.name}
                </PreMatchParticipantNameNfl>
            </PreMatchParticipants>

            <NFLIconWrapper />
        </PreMatchWrapperNfl>
    );
});
